import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-501f03df"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"margin-bottom":"20px"} }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"green"} }, " 请选择要查询的开始日期和结束日期(查询一天请选择同一天) ", -1))
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 查询 ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("全部")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("未开工")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("已开工未完结")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("已完结")
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "用于补片单交接,在所有补片单中唯一", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "补片条码", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "在该订单中唯一", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "订单序号", -1))
const _hoisted_12 = /*#__PURE__*/_createTextVNode("×")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("=")
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" 订单编号 ")
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" 流程卡号 ")
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" 客户名称 ")
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" 成品名称 ")
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" 工艺流程 ")
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" 开工 ")
const _hoisted_20 = /*#__PURE__*/_createTextVNode("完结")
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" 交出 ")
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" 接收 ")
const _hoisted_23 = /*#__PURE__*/_createTextVNode(" 最后交接时间 ")
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" 申报 ")
const _hoisted_25 = /*#__PURE__*/_createTextVNode(" 责任 ")
const _hoisted_26 = /*#__PURE__*/_createTextVNode(" 申报人员 ")
const _hoisted_27 = /*#__PURE__*/_createTextVNode(" 申报时间 ")
const _hoisted_28 = /*#__PURE__*/_createTextVNode(" 备注 ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_range_picker = _resolveComponent("a-range-picker")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_input_group = _resolveComponent("a-input-group")!
  const _component_a_descriptions_item = _resolveComponent("a-descriptions-item")!
  const _component_a_radio_button = _resolveComponent("a-radio-button")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_descriptions = _resolveComponent("a-descriptions")!
  const _component_a_page_header = _resolveComponent("a-page-header")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_popover = _resolveComponent("a-popover")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_page_header, {
      class: "demo-page-header",
      style: {"border":"1px solid rgb(235, 237, 240)","margin-bottom":"8px"},
      title: `补片明细(${_ctx.patchListSearch.length}/${_ctx.patchList.length})`,
      "sub-title": "查询/跟踪补片进度"
    }, {
      extra: _withCtx(() => []),
      default: _withCtx(() => [
        _createVNode(_component_a_descriptions, {
          size: "small",
          column: 3
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_descriptions_item, { label: "补片日期" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input_group, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_range_picker, {
                      value: _ctx.patchDateValue,
                      "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.patchDateValue) = $event)),
                      format: "YYYY-MM-DD",
                      placeholder: ['开始时间', '结束时间'],
                      onChange: _ctx.onChangeDate,
                      style: {"vertical-align":"bottom"}
                    }, {
                      renderExtraFooter: _withCtx(() => [
                        _hoisted_2
                      ]),
                      _: 1
                    }, 8, ["value", "onChange"]),
                    _createVNode(_component_a_button, {
                      type: "primary",
                      onClick: _ctx.getPatchList,
                      style: {"margin-left":"8px"}
                    }, {
                      default: _withCtx(() => [
                        _hoisted_3
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_a_descriptions_item, { label: "补片状态" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_radio_group, {
                  value: _ctx.stateValue,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.stateValue) = $event)),
                  "button-style": "solid"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_radio_button, { value: "all" }, {
                      default: _withCtx(() => [
                        _hoisted_4
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_radio_button, { value: "not" }, {
                      default: _withCtx(() => [
                        _hoisted_5
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_radio_button, { value: "start" }, {
                      default: _withCtx(() => [
                        _hoisted_6
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_radio_button, { value: "end" }, {
                      default: _withCtx(() => [
                        _hoisted_7
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_descriptions_item, { label: "客户名称" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select, {
                  style: {"width":"160px"},
                  value: _ctx.clientValue,
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.clientValue) = $event)),
                  placeholder: "请选择客户",
                  dropdownMatchSelectWidth: false,
                  "show-search": "",
                  onSearch: _ctx.handleSearchClient
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.clientListSearch, (item) => {
                      return (_openBlock(), _createBlock(_component_a_select_option, {
                        value: item,
                        key: item
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item), 1)
                        ]),
                        _: 2
                      }, 1032, ["value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["value", "onSearch"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["title"]),
    _createVNode(_component_a_row, {
      type: "flex",
      gutter: [0, 16]
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.patchListSearch, (item) => {
          return (_openBlock(), _createBlock(_component_a_col, {
            span: 24,
            key: item.id
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_card, {
                style: {"width":"100%"},
                bodyStyle: "padding: 12px; box-shadow: 0 6px 10px rgb(0 0 0 / 6%);"
              }, {
                actions: _withCtx(() => []),
                default: _withCtx(() => [
                  _createElementVNode("div", null, [
                    _createVNode(_component_a_row, {
                      type: "flex",
                      style: {"border-bottom":"1px solid #f0f0f0","padding-bottom":"8px","margin-bottom":"8px"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_col, {
                          span: 7,
                          style: {"margin-bottom":"8px"}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_row, {
                              gutter: [0, 16],
                              style: {"padding-bottom":"8px"}
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_col, {
                                  span: 12,
                                  style: {"border-bottom":"1px solid #f0f0f0"}
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_tag, { color: "cyan" }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(item.typename), 1)
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createVNode(_component_a_popover, { placement: "top" }, {
                                      content: _withCtx(() => [
                                        _hoisted_8
                                      ]),
                                      title: _withCtx(() => [
                                        _hoisted_9
                                      ]),
                                      default: _withCtx(() => [
                                        _createVNode(_component_a_tag, { color: "#1890ff" }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(" -" + _toDisplayString(item.id), 1)
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createVNode(_component_a_popover, { placement: "top" }, {
                                      content: _withCtx(() => [
                                        _hoisted_10
                                      ]),
                                      title: _withCtx(() => [
                                        _hoisted_11
                                      ]),
                                      default: _withCtx(() => [
                                        _createVNode(_component_a_tag, { color: "#881bf1" }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(item.SOSeqNo), 1)
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode(_component_a_col, {
                                  span: 12,
                                  style: {"border-bottom":"1px solid #f0f0f0","border-left":"1px solid #f0f0f0"}
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_row, {
                                      type: "flex",
                                      justify: "space-around",
                                      style: {"text-align":"center","font-size":"16px"},
                                      gutter: [0, 16]
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_a_col, { span: 8 }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_a_tag, {
                                              color: "orange",
                                              style: {"font-size":"16px"}
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(item.ItemLength), 1)
                                              ]),
                                              _: 2
                                            }, 1024)
                                          ]),
                                          _: 2
                                        }, 1024),
                                        _createVNode(_component_a_col, { span: 1 }, {
                                          default: _withCtx(() => [
                                            _hoisted_12
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_a_col, { span: 8 }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_a_tag, {
                                              color: "orange",
                                              style: {"font-size":"16px"}
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(item.ItemWidth), 1)
                                              ]),
                                              _: 2
                                            }, 1024)
                                          ]),
                                          _: 2
                                        }, 1024),
                                        _createVNode(_component_a_col, { span: 1 }, {
                                          default: _withCtx(() => [
                                            _hoisted_13
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_a_col, { span: 6 }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_a_tag, {
                                              color: "green",
                                              style: {"font-size":"16px"}
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(item.Qty), 1)
                                              ]),
                                              _: 2
                                            }, 1024)
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode(_component_a_col, {
                                  span: 12,
                                  style: {"border-bottom":"1px solid #f0f0f0"}
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_tag, { color: "orange" }, {
                                      default: _withCtx(() => [
                                        _hoisted_14
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_a_tag, null, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(item.SONO), 1)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode(_component_a_col, {
                                  span: 12,
                                  style: {"border-bottom":"1px solid #f0f0f0"}
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_tag, { color: "purple" }, {
                                      default: _withCtx(() => [
                                        _hoisted_15
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_a_tag, null, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(item.PCNO), 1)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_a_col, {
                          span: 7,
                          style: {"padding-left":"8px","border-left":"1px solid #f0f0f0"}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_row, {
                              type: "flex",
                              justify: "space-around",
                              gutter: [0, 16]
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_col, { span: 24 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_tag, { color: "#09a74d" }, {
                                      default: _withCtx(() => [
                                        _hoisted_16
                                      ]),
                                      _: 1
                                    }),
                                    _createElementVNode("span", null, _toDisplayString(item.custbrief), 1)
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode(_component_a_col, { span: 24 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_tag, { color: "#C43E1C" }, {
                                      default: _withCtx(() => [
                                        _hoisted_17
                                      ]),
                                      _: 1
                                    }),
                                    _createElementVNode("span", null, _toDisplayString(item.itemname), 1)
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode(_component_a_col, { span: 24 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_tag, { color: "pink" }, {
                                      default: _withCtx(() => [
                                        _hoisted_18
                                      ]),
                                      _: 1
                                    }),
                                    _createElementVNode("span", null, _toDisplayString(item.RouteStr), 1)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_a_col, {
                          span: 4,
                          style: {"padding-left":"8px","border-left":"1px solid #f0f0f0"}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_row, { gutter: [0, 16] }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_col, { span: 10 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_row, {
                                      gutter: [0, 16],
                                      style: {"border-right":"1px solid #f0f0f0"}
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_a_col, { span: 24 }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_a_tag, { color: "#fa8c16" }, {
                                              default: _withCtx(() => [
                                                _hoisted_19
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_component_a_tag, {
                                              color: 
                            item.StartQty === 0
                              ? 'default'
                              : item.StartQty === item.Qty
                              ? 'green'
                              : 'blue'
                          
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(item.StartQty), 1)
                                              ]),
                                              _: 2
                                            }, 1032, ["color"])
                                          ]),
                                          _: 2
                                        }, 1024),
                                        _createVNode(_component_a_col, { span: 24 }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_a_tag, { color: "#fa8c16" }, {
                                              default: _withCtx(() => [
                                                _hoisted_20
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_component_a_tag, {
                                              color: 
                            item.FinishQty === 0
                              ? 'default'
                              : item.FinishQty === item.Qty
                              ? 'green'
                              : 'blue'
                          
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(item.FinishQty), 1)
                                              ]),
                                              _: 2
                                            }, 1032, ["color"])
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode(_component_a_col, {
                                  span: 14,
                                  style: {"padding-left":"8px","border-left":"1px solid #f0f0f0"}
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_row, { gutter: [0, 16] }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_a_col, { span: 24 }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_a_tag, { color: "#1890ff" }, {
                                              default: _withCtx(() => [
                                                _hoisted_21
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_component_a_tag, null, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(item.log_FRWIPName), 1)
                                              ]),
                                              _: 2
                                            }, 1024)
                                          ]),
                                          _: 2
                                        }, 1024),
                                        _createVNode(_component_a_col, { span: 24 }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_a_tag, { color: "#1890ff" }, {
                                              default: _withCtx(() => [
                                                _hoisted_22
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_component_a_tag, null, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(item.log_ToWIPName), 1)
                                              ]),
                                              _: 2
                                            }, 1024)
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode(_component_a_col, { span: 24 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_tag, { color: "pink" }, {
                                      default: _withCtx(() => [
                                        _hoisted_23
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_a_tag, null, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(item.log_approvedate), 1)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_a_col, {
                          span: 6,
                          style: {"padding-left":"8px","border-left":"1px solid #f0f0f0"}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_row, { gutter: [0, 16] }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_col, { span: 12 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_tag, { color: "blue" }, {
                                      default: _withCtx(() => [
                                        _hoisted_24
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_a_tag, null, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(item.frWTName), 1)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode(_component_a_col, { span: 12 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_tag, { color: "blue" }, {
                                      default: _withCtx(() => [
                                        _hoisted_25
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_a_tag, null, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(item.toWTName), 1)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode(_component_a_col, { span: 24 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_tag, { color: "blue" }, {
                                      default: _withCtx(() => [
                                        _hoisted_26
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_a_tag, null, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(item.Approver), 1)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode(_component_a_col, { span: 24 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_tag, { color: "pink" }, {
                                      default: _withCtx(() => [
                                        _hoisted_27
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_a_tag, null, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(item.ApproveDate), 1)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_a_row, {
                      type: "flex",
                      justify: "space-around",
                      gutter: [0, 16]
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_col, { span: 18 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_tag, { color: "#3B5999" }, {
                              default: _withCtx(() => [
                                _hoisted_28
                              ]),
                              _: 1
                            }),
                            _createElementVNode("span", null, _toDisplayString(item.workcontent), 1)
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_a_col, {
                          span: 6,
                          style: {"padding-left":"8px","border-left":"1px solid #f0f0f0"}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_tag, { color: "#3B5999" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(item.typename) + "原因 ", 1)
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(_component_a_tag, null, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(item.Remark), 1)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024)
                  ])
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1024))
        }), 128))
      ]),
      _: 1
    })
  ]))
}